export const Internationalization = {
  allItemsAreSelected: 'Todos os itens selecionados.',
  clearSearch: 'Limpar pesquisa',
  noOptions: 'Sem opções',
  search: 'Pesquisar',
  selectAll: 'Selecionar todos',
  selectAllFiltered: 'Selecionar todos os encontrados',
  create: 'Criar',
  selectSomeItems: 'Selecione...',
};
